import { Notify } from 'util/notify';

const OpenNotification = ({ type, title: message, ...rest }) => Notify[type]({ message, ...rest });

export default OpenNotification;
